module.exports = __webpack_public_path__ + "img/android.5c54d49b.svg";